import Axios from 'axios'
import {Message, Loading, MessageBox} from 'element-ui'
import router from '../router'
import {delCookie, getCookie} from "../assets/js/utils";

let LoadingInstance;
let loadings = 0;
let timer = undefined;
let tokenIsInvalidTipIsDisplayed = false;
const product = `${process.env.VUE_APP_MAIN_HOST}/iot/Product`
const serve = `${process.env.VUE_APP_MAIN_HOST}/iot/ProductServe`
const property = `${process.env.VUE_APP_MAIN_HOST}/iot/ProductServeProperty`
const command = `${process.env.VUE_APP_MAIN_HOST}/iot/ProductServeCommand`
const device = `${process.env.VUE_APP_MAIN_HOST}/iot/Device`

export const showLoading = () => {
    if (loadings === 0) {
        LoadingInstance = Loading.service({ fullscreen: true, background: 'transparent' })
        timer = setTimeout(() => {
            if (LoadingInstance) {
                LoadingInstance.close()
                LoadingInstance = undefined
            }
            clearTimeout(timer)
            timer = undefined
        }, 15000)
    }
    loadings++
}

export const hideLoading = () => {
    loadings--
    if (loadings <= 0) {
        LoadingInstance && LoadingInstance.close()
        LoadingInstance = undefined
        if (timer) {
            clearTimeout(timer)
            timer = undefined
        }
    }
}

let axios = Axios.create()

axios.interceptors.response.use(function (res) {
    hideLoading()
    if ((res.status >= 200 && res.status <= 204) || res.status === 304) {
        return res.data
    }
    return Promise.reject(res)
}, function (error) {
    hideLoading()
    if (error && error.response && error.response.status) {
        switch (error.response.status) {
            case 401:
                delCookie('Authorization')
                if (!tokenIsInvalidTipIsDisplayed) {
                    tokenIsInvalidTipIsDisplayed = true
                    MessageBox.confirm('登陆失效,请重新登录', '提示', {
                        confirmButtonText: '确定',
                        // center: true,
                        showCancelButton: false,
                        type: "error",
                        callback: action => {
                            router.push({path: '/'})
                        }
                    })
                }
                break
            case 403:
                Message({
                    type: 'error',
                    message: '没有权限！'
                })
                throw Error('UnauthorizedException');
            default:
                Message({
                    type: 'error',
                    message: '网络错误！',
                })
                break
        }
    }
    return Promise.reject(error)
});

export async function post (url, data, headers = { 'Content-Type': 'application/json' }, submitAuthorization = false) {
    showLoading()
    if (getCookie('Authorization') && !submitAuthorization) {
        headers['Authorization'] = getCookie('Authorization')
    }
    if (!submitAuthorization) {
        data = JSON.stringify(data)
    }
    return await axios.post(url, data, {
        headers
    })
}

export async function get (url, data = {}) {
    showLoading()
    let headers = {}
    if (getCookie('Authorization')) {
        headers  = {
            'Authorization': getCookie('Authorization')
        }
    }
    return await axios.get(url, {
        params: data,
        headers,
    })
}

export function dealErrorCode(code) {
    // 产品不存在 21001
    switch (code) {
        case 31001:
            Message({
                type: 'error',
                message: '服务已经存在！'
            })
            return false;
        case 31002:
            Message({
                type: 'error',
                message: '华为云设备注册失败！'
            })
            return false;
        case 31003:
            Message({
                type: 'error',
                message: '设备名称重复！'
            })
            return false;
        case 31004:
            Message({
                type: 'error',
                message: '设备标识码重复！'
            })
            return false;
        case 31005:
            Message({
                type: 'error',
                message: '子设备最高存在两层！'
            })
            return false;
        case 31006:
            Message({
                type: 'error',
                message: '该产品下仍有设备不可删除！'
            })
            return false;
        case 31007:
            Message({
                type: 'error',
                message: '失败验证失败！'
            })
            return false;
        case 31008:
            Message({
                type: 'error',
                message: '设备属性同步失败！'
            })
            return false;
        case 31009:
            Message({
                type: 'error',
                message: '设备属性不匹配！'
            })
            return false;
        case 31010:
            Message({
                type: 'error',
                message: '设备命令参数不匹配！'
            })
            return false;
        case 31011:
            Message({
                type: 'error',
                message: '云服务商对接失败！'
            })
            return false;
        case 31012:
            Message({
                type: 'error',
                message: '设备属性名重复！'
            })
            return false;
        case 31013:
            Message({
                type: 'error',
                message: '设备命令名重复！'
            })
            return false;
        case 31014:
            Message({
                type: 'error',
                message: '产品名称重复！'
            })
            return false;
            case 31015:
                Message({
                    type: 'error',
                    message: '设备协议类型密钥仅允许十六进制数字！'
                })
                return false; 
    }
    return true
}

export default {
    state: {

    },
    getters: {

    },
    mutations: {

    },
    actions: {
        async UploadOss({commit}, {oss, file, filename}) {
            let blob
            if (typeof (file) !== 'object') {
                let bytes = window.atob(file.split(',')[1])

                let array = []
                for (let i = 0; i < bytes.length; i++) {
                    array.push(bytes.charCodeAt(i))
                }
                let base64Type = file.slice(file.indexOf(':') + 1, file.indexOf(';'))

                blob = new Blob([new Uint8Array(array)], {
                    type: base64Type
                })
            } else {
                blob = file
            }

            let data = new FormData()

            data.append('callback', oss.callback)
            data.append('key', oss.bucketNameFile)
            data.append('bucket', oss.bucketName)
            data.append('x-oss-meta-tag', 'dummy_etag_xxx')
            data.append('OSSAccessKeyId', oss.accessKeyId)
            data.append('policy', oss.encPolicy)
            data.append('Signature', oss.signature)
            data.append('file', blob, filename)
            data.append('success_action_status', '200')

            let timer = setTimeout(() => showLoading && showLoading(), 1000)

            await fetch(oss.requestUri, {
                method: 'POST',
                body: data
            })
            clearTimeout(timer)
            hideLoading && hideLoading()
        },
        CreateProduct(store, {name, protocolType, dataEncode, companyName, industry, deviceType, serves}) {
            return post(`${product}/CreateProduct`, {name, protocolType, dataEncode, companyName, industry, deviceType, serves})
        },
        DeleteProduct(store, productId) {
            return post(`${product}/DeleteProduct`, {productId})
        },
        GetProductList(store, {page, limit}) {
            return get(`${product}/GetProductList`, {page, limit})
        },
        GetProductDetail(store, productId) {
            return get(`${product}/GetProductDetail`, {productId})
        },
        AddServe(store, {id, productId, type, description, properties}) {
            return post(`${serve}/AddServe`, {id, productId, type, description, properties})
        },
        DeleteServe(store, {serveId, productId}) {
            return post(`${serve}/DeleteServe`, {serveId, productId})
        },
        AddProperty(store, {id, productId, serveId, name, isRequired, access, propertyType,
            maxValue, minValue, stepLength, unit, length, enumData}) {
            return post(`${property}/AddProperty`, {id, productId, serveId, name, isRequired, access, propertyType,
                maxValue, minValue, stepLength, unit, length, enum: enumData})
        },
        EditProperty(store, {id, productId, serveId, name, isRequired, access, propertyType,
            maxValue, minValue, stepLength, unit, length, enumData,}) {
            return post(`${property}/EditProperty`, {id, productId, serveId, name, isRequired, access, propertyType,
                maxValue, minValue, stepLength, unit, length, enum: enumData})
        },
        DeleteProperty(store, {productId, serveId, propertyId}) {
            return post(`${property}/DeleteProperty`, {productId, serveId, propertyId})
        },
        AddCommand(store, {id, productId, serveId, name, inputParameters, outputParameters}) {
            return post(`${command}/AddCommand`, {id, productId, serveId, name, inputParameters, outputParameters})
        },
        DeleteCommand(store, {productId, serveId, commandId}) {
            return post(`${command}/DeleteCommand`, {productId, serveId, commandId})
        },
        EditCommand(store, {id, productId, serveId, name, inputParameters, outputParameters}) {
            return post(`${command}/EditCommand`, {id, productId, serveId, name, inputParameters, outputParameters})
        },
        SaveToModel(store, {productId, modelName}) {
            return post(`${product}/SaveToModel`, {productId, modelName})
        },
        GetModelList(store, {page, limit, search}) {
            return get(`${product}/GetModelList`, {page, limit, search})
        },
        ImportFromModel(store, {productId, modelId}) {
            return post(`${product}/ImportFromModel`, {productId, modelId})
        },
        AddDevice(store, {parentId, productId, name, nodeId, secret}) {
            return post(`${device}/AddDevice`, {parentId, productId, name, nodeId, secret})
        },
        DeleteDevice(store, deviceId) {
            return post(`${device}/DeleteDevice`, {deviceId})
        },
        FreezeDevice(store, deviceId) {
            return post(`${device}/FreezeDevice`, {deviceId})
        },
        UnfreezeDevice(store, deviceId) {
            return post(`${device}/UnfreezeDevice`, {deviceId})
        },
        GetDeviceDetail(store, deviceId) {
            return get(`${device}/GetDeviceDetail`, {deviceId})
        },
        GetDeviceList(store, {page, limit, search, searchType, productId, parentId}) {
            return get(`${device}/GetDeviceList`, {page, limit, search, searchType, productId, parentId})
        },
        SendCommand(store, {deviceId, serveId, commandName, params, cacheTime, type}) {
            return post(`${device}/SendCommand`, {deviceId, serveId, commandName, params, cacheTime, type})
        },
        GetCommandList(store, {deviceId, page, limit, search, begin, end}) {
            return get(`${device}/GetCommandList`, {deviceId, page, limit, search, begin, end})
        },
        GetShadow(store, deviceId) {
            return get(`${device}/GetShadow`, {deviceId})
        },
        SetShadow(store, {deviceId, properties}) {
            return post(`${device}/SetShadow`, {deviceId, properties})
        },
        ResetSecret(store, {deviceId, secret}) {
            return post(`${device}/ResetSecret`, {deviceId, secret})
        },

    }

}
